/**
 * @deprecated
 * Includes are deprecated. See IMP-1330
 */
export enum OBSERVATION_INCLUDES {
  DATASETS = "datasets",
}
